<template>
  <div id="app">
    <!-- <headPage /> -->
    <router-view/>
    <!-- <footPage></footPage> -->
  </div>
</template>

<script>
import enduserAPI from '@/api/enduser';
import publicAPI from '@/api/public';
import headPage from '@/components/headPage';
import footPage from '@/components/footPage';
import wSocket from "../config/wSocket";
export default {
  name: 'App',
  components: {
    footPage,
    headPage,
  },
  data() {
    return {
      serviceObj: {},
      messageTimer: false,
      headShow: false,
      timerOut: null,
    };
  },
  watch: {
    // $route: {
    //   handler: function (val) {
    //     this.headShow = !(['help', 'about'].includes(val.name))
    //   },
    //   deep: true
    // }
  },
  mounted() {
    // this.getcur()
    // this.getprofile()
    // window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    getcur(){
      publicAPI.getcur().then(({ list }) => {
        localStorage.setItem('curData', JSON.stringify(list))          
      });
    },
    getprofile(){
      enduserAPI.getprofile().then(({ Caption, id, payments, BindTel, BindMail, CountryTel, CountryCode, VerifyEndUserDetail, subaccts, UplineDirect }) => {
        this.isLogin = true
        const parsobj = {
          flag: false,
          phone: BindTel
        };
        sessionStorage.setItem('payload', JSON.stringify(parsobj));
        sessionStorage.setItem('UplineDirect', UplineDirect);
      });
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const nav = document.getElementById('nav');
      if (scrollTop > 30) {
        nav.style.background = 'rgba(9,6,53,0.8)';
      }else{
        nav.style.background = 'rgba(9,6,53,0.4)';
      }
    },
  },
}
</script>

<style>
#app {
  font-family: Helvetica,Pingfang SC,Hiragino Sans GB,Microsoft YaHei,WenQuanYi Micro Hei,"sans-serif";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* color: #2c3e50; */
  /* font-size: 20px; */
}
*{
  margin: 0;
  padding: 0;
  /* -webkit-user-select:none;
	-moz-user-select:none;
	-ms-user-select:none;
	user-select:none; */
}
/* a{
  text-decoration: none
} */
input, textarea {
    user-select: text;  
}
html, body {
    width: 100%;
    height: 100%;
}
/*滚动条样式*/
body::-webkit-scrollbar {/*滚动条整体样式*/
    width: 6px;     /*高宽分别对应横竖滚动条的尺寸*/
}
body::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: #CCC;
}
body::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 0;
    background: #999;
}
.el-button{
  border-radius: 2px!important
}
li{
  list-style: none
}
input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    input[type="number"]{
        -moz-appearance: textfield;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue